import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets scroll position on route changes.
 * - If the URL has a hash (e.g. /#faq), scrolls to that element.
 * - Otherwise, scrolls to the top of the page.
 *
 * React Router doesn't do this by default; without it, the user lands
 * wherever the previous page was scrolled to, and #-anchor links don't work.
 */
export default function ScrollToHashOrTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Try immediately, and again on next frame in case the target hasn't
      // mounted yet (sections that render after data fetches, etc.)
      const id = hash.startsWith('#') ? hash.slice(1) : hash;
      const tryScroll = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return true;
        }
        return false;
      };
      if (!tryScroll()) {
        // One retry on the next paint, then give up gracefully
        requestAnimationFrame(() => { tryScroll(); });
      }
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }
  }, [pathname, hash]);

  return null;
}
